import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryFileUploadInitiateService = (
  data: any,
  signal: AbortSignal,
) => {
  return axiosInstance
    .post(ENDPOINTS.ADMIN.EXTERNAL_DELIVERY.UPLOAD.INITIATE, data, { signal })
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
